import { useCallback } from 'react';
import { useWeb5Context } from "../../../lib/Web5Context";
import { fieldOperators, operatorsToBeShownOnlyInCrossFilters, DIVIDER } from "../operators";
const useAdvancedFilters = _ref => {
  let {
    operators,
    crossOperators,
    getAllowedOperators = () => {},
    getFieldsWithoutAdvancedFilters = () => {},
    getHasAdvancedFilters = () => {}
  } = _ref;
  const {
    t
  } = useWeb5Context();
  const getFieldOperator = useCallback((field, crossEntity) => {
    const currentOperators = !!crossEntity && !field.isFakeCrossFilter ? (crossOperators === null || crossOperators === void 0 ? void 0 : crossOperators[crossEntity]) || {} : operators;
    const {
      id
    } = field;
    const operator = currentOperators && currentOperators[id];
    return operator ? operator.value : undefined;
  }, [operators, crossOperators]);
  const getOperatorValues = useCallback((field, current, crossEntity) => {
    var _getAllowedOperators;
    const valuesObj = fieldOperators[field];
    if (!valuesObj) return {
      options: [],
      value: null
    };
    const {
      operators,
      default: defaultValue
    } = valuesObj;
    const allowedOperators = (_getAllowedOperators = getAllowedOperators(crossEntity)) === null || _getAllowedOperators === void 0 ? void 0 : _getAllowedOperators[field];
    const valuesArr = Object.entries(operators).reduce((arr, _ref2) => {
      let [key, value] = _ref2;
      // Filters the advanced filters meant to be shown only when in crossfilters context (crossEntity = null)
      if (!crossEntity && operatorsToBeShownOnlyInCrossFilters.includes(value)) return arr;
      if (allowedOperators && (allowedOperators.includes(value) || value === DIVIDER) || !allowedOperators) {
        const newValue = value === DIVIDER ? {
          divider: true
        } : {
          label: t(key),
          value
        };
        return [...arr, newValue];
      } else {
        return arr;
      }
    }, []);
    const currentValue = current || defaultValue;
    const value = valuesArr.filter(item => item.value === currentValue)[0];
    const operatorDefaultValue = valuesArr.filter(item => item.value === defaultValue)[0];
    return {
      options: valuesArr,
      value,
      defaultValue: operatorDefaultValue
    };
  }, [getAllowedOperators, t]);
  const hasAdvancedFilters = useCallback(_ref3 => {
    let {
      id,
      dataType,
      crossEntity,
      avoidAdvancedFilter = false
    } = _ref3;
    const allowedOperators = getAllowedOperators(crossEntity);
    const advancedFilters = getHasAdvancedFilters(crossEntity);
    const fieldsWithoutAdvancedFilters = getFieldsWithoutAdvancedFilters(crossEntity);
    if (avoidAdvancedFilter) return false;
    if (fieldsWithoutAdvancedFilters !== null && fieldsWithoutAdvancedFilters !== void 0 && fieldsWithoutAdvancedFilters.includes(id)) return false;
    return advancedFilters && (!allowedOperators || allowedOperators[dataType]);
  }, [getAllowedOperators, getFieldsWithoutAdvancedFilters, getHasAdvancedFilters]);
  return {
    getFieldOperator,
    getOperatorValues,
    hasAdvancedFilters
  };
};
export default useAdvancedFilters;